// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce
    .easycommerce-add-to-cart-quantity-block
    .easycommerce-qunatity-input {
    border: none;
    background-color: #fff;
    width: 65px;
}
.easycommerce
    .easycommerce-add-to-cart-quantity-block
    .easycommerce-qunatity-input:focus {
    outline: 0;
    box-shadow: none;
    border: none;
}
.easycommerce-add-to-cart-button:hover,
.easycommerce-add-to-cart-button:focus {
    /* color: var(--color-ec-primary); */
    background-color: var(--color-ec-primary);
}
.easycommerce .easycommerce-qunatity-input {
    box-shadow: none;
}
.easycommerce .easycommerce-qunatity-input:focus {
    border: none !important;
}
.easycommerce .easycommerce-quantity-minus-btn:hover,
.easycommerce .easycommerce-quantity-plus-btn:hover,
.easycommerce .easycommerce-quantity-minus-btn:focus,
.easycommerce .easycommerce-quantity-plus-btn:focus {
    border-color: #1203501a;
}
`, "",{"version":3,"sources":["webpack://./blocks/single-product/add-to-cart/style.css"],"names":[],"mappings":"AAAA;;;IAGI,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;AACA;;;IAGI,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;AACA;;IAEI,oCAAoC;IACpC,yCAAyC;AAC7C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;;;;IAII,uBAAuB;AAC3B","sourcesContent":[".easycommerce\n    .easycommerce-add-to-cart-quantity-block\n    .easycommerce-qunatity-input {\n    border: none;\n    background-color: #fff;\n    width: 65px;\n}\n.easycommerce\n    .easycommerce-add-to-cart-quantity-block\n    .easycommerce-qunatity-input:focus {\n    outline: 0;\n    box-shadow: none;\n    border: none;\n}\n.easycommerce-add-to-cart-button:hover,\n.easycommerce-add-to-cart-button:focus {\n    /* color: var(--color-ec-primary); */\n    background-color: var(--color-ec-primary);\n}\n.easycommerce .easycommerce-qunatity-input {\n    box-shadow: none;\n}\n.easycommerce .easycommerce-qunatity-input:focus {\n    border: none !important;\n}\n.easycommerce .easycommerce-quantity-minus-btn:hover,\n.easycommerce .easycommerce-quantity-plus-btn:hover,\n.easycommerce .easycommerce-quantity-minus-btn:focus,\n.easycommerce .easycommerce-quantity-plus-btn:focus {\n    border-color: #1203501a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
